import { GenderEnum } from '~/apis/ssf';

export const genderOptions = ['M', 'F', 'B'];

export function genderNameToLabel(name: GenderEnum, opts?: { mixedLabel?: string }) {
  return {
    M: 'Man',
    F: 'Kvinna',
    B: opts?.mixedLabel ?? 'Alla',
  }[name];
}
